(ns io.daskul.webapp.widgets.form.input-type
  "Schema + :ui hints -> the input widget a form field renders.

   Pure logic, no React or re-frame, so it is unit-testable under :node-test.
   Schemas arrive from the API over JSON and are therefore strings —
   \"double\", [\"maybe\" \"double\"] — never keywords.")

(defn unwrap-maybe
  "Unwrap [:maybe X] -> X, pass through anything else."
  [schema]
  (if (and (vector? schema) (= "maybe" (first schema)))
    (second schema)
    schema))

(def ^:private numeric-schemas #{"int" "double"})

(defn schema->input-type
  "Convert schema + ui hints to input type."
  [schema ui]
  (let [widget (:widget ui)
        schema-type (when (vector? schema) (first schema))
        unwrapped (unwrap-maybe schema)
        unwrapped-type (when (vector? unwrapped) (first unwrapped))
        inner-schema (when (and (vector? schema) (= "vector" schema-type))
                       (second schema))
        inner-type (when (vector? inner-schema) (first inner-schema))]
    (cond
      (= widget "date") :date
      (= widget "time") :time
      (= widget "weekday-toggle") :weekday-toggle
      (= widget "value-with-unit") :value-with-unit
      (= widget "inline-table") :inline-table
      (= widget "collection") :collection
      (contains? #{"select" "radio" "radio-card" "segmented" "autocomplete"
                   "multi-select" "checkbox" "lookup"} widget)
      :selector
      (= widget "compound") :compound
      (= widget "switch") :switch
      (= widget "textarea") :textarea
      (= widget "email") :email
      (= widget "password") :password
      (= widget "phone") :phone
      (and (= schema-type "vector") (= inner-type "enum")) :selector
      (= schema-type "enum") :selector
      (= unwrapped-type "enum") :selector
      (or (= schema "boolean") (= unwrapped "boolean")) :switch
      (contains? numeric-schemas unwrapped) :number
      :else :text)))
